import React, { useState, useMemo } from 'react'
import { Card, Select, Pagination, Empty } from 'antd'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Legend,
  CartesianGrid,
} from 'recharts'

export default function DepartmentTicketsChart({ departmentTicketsChartData }) {
  const [view, setView] = useState('ALL')
  const [page, setPage] = useState(1)
  const pageSize = 3
  const { Option } = Select

  // ✅ derive data directly from state
  const data = departmentTicketsChartData?.[view] || []

  const pagedData = useMemo(() => {
    const start = (page - 1) * pageSize
    return data.slice(start, start + pageSize)
  }, [data, page])

  const handleDateOptionChange = (value) => {
    setView(value)
    setPage(1)
  }

  return (
    <Card size='small' className='department-tickets-card'>
      <div className='chart-header'>
        <div className='chart-title'>
          <span className='ticket-count'>
            Open vs Resolved Tickets by Department
          </span>
          <Select
            value={view}
            onChange={handleDateOptionChange}
            size='small'
            style={{ width: 150 }}
          >
            <Option value='ALL'>All</Option>
            <Option value='today'>Today</Option>
            <Option value='thisWeek'>This Week</Option>
            <Option value='lastWeek'>Last Week</Option>
            <Option value='thisMonth'>This Month</Option>
            <Option value='lastMonth'>Last Month</Option>
          </Select>
        </div>
      </div>

      {pagedData.length > 0 ? (
        <>
          <ResponsiveContainer width='100%' height={468}>
            <BarChart
              data={pagedData}
              margin={{ top: 10, right: 10, left: 10, bottom: 10 }}
            >
              <CartesianGrid strokeDasharray='3 3' vertical={false} />
              <XAxis
                dataKey='department_Name'
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12 }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12 }}
              />
              <Bar dataKey='resolved' fill='#FF4D4F' barSize={20} />
              <Bar dataKey='open' fill='#1890FF' barSize={20} />
              <Legend verticalAlign='top' height={36} />
            </BarChart>
          </ResponsiveContainer>

          <div style={{ textAlign: 'center' }}>
            <Pagination
              current={page}
              pageSize={pageSize}
              total={data.length}
              onChange={setPage}
              size='small'
            />
          </div>
        </>
      ) : (
        <div
          style={{
            height: 468,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Empty description='No Tickets Found' />
        </div>
      )}
    </Card>
  )
}
